import React from 'react'
import parse from 'html-react-parser'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import Arrow from '../../images/chevron_right.svg'
import { WpMediaImage } from '../../elementor'
import { SlideT } from '../../elementor/slides-widget'

interface SlideProps {
  slide: SlideT
  img?: WpMediaImage
}

const SlideExperiment = ({ slide, img }: SlideProps ) => {
  const { heading, button_text, description, link } = slide
  const background_image = slide.background_image?.url ?? slide.background_image?.alt

  return (
    <swiper-slide>
      <div className='slide-wrapper'>
        <div className='slide-image'>
          <AniLink href={link.url} className='background-link'>
            <img className='background-img' src={background_image}/>
            <div className='slide-content'>
              <h5>{parse(heading || '')}</h5>
              <p className='slide-description'>{parse(description || '')}</p>
              {(button_text !== undefined && button_text !== null) ? 
                <div className='thumbnail-and-link'>
                  <img className='thumbnail' src={img?.fileUrl} alt={img?.altText} />
                  <div className='condition-link'>
                    <span className='condition-text'>{button_text}</span>
                    <img className='arrow' src={Arrow} alt='arrow right' />
                  </div>
                </div>
              : null}
            </div>
          </AniLink>
        </div>
      </div>
    </swiper-slide>
  )
}

export default SlideExperiment
